export enum reportTypeEnum {
  brsr = 'brsr',
  ca = 'ca',
  gri = 'gri',
  tcfd = 'tcfd',
  cdp = 'cdp',
  cdp_corporate = 'cdpcorporate',
  cbam_iron_and_steel = 'cbamironandsteel'
}
